<template>
  <div
    v-if="errorMessage"
    :id="`error-${props.errorTestId || 'inline-warning-message'}`"
    class="w-full flex items-top gap-2 bg-ruby-red-5 rounded-lg border-ruby-red-5 p-4 mb-2"
    role="alert">
    <WarningTriangleIcon
      title="Error:"
      class="shrink-0 text-ruby-red-100"
    />
    <p>
      <span
        v-if="filename"
        class="data-hj-suppress">
        <strong class="break-all">{{ filename }}: </strong>
      </span>
      <span>{{ messageText }}</span>
    </p>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import WarningTriangleIcon from '../ui-components/icons/WarningTriangleIcon.vue'
import stripHtml from '@/utils/stripHtml'

const props = defineProps<{
  errorMessage?: string
  errorTestId?: string
}>()

const errorMessage = computed(() => stripHtml(props.errorMessage || ''))

/**
 * Extracts filename from error messages for Hotjar suppression
 * Pattern: "filename.ext: error message"
 */
const filename = computed(() => {
  const message = errorMessage.value
  if (!message) return ''

  // Match filename at start (before first colon)
  const match = message.match(/^([^:]+\.[a-zA-Z0-9]+):/)
  return match ? match[1] : ''
})

/**
 * Returns the message text without the filename prefix
 */
const messageText = computed(() => {
  const message = errorMessage.value
  if (!message) return ''

  if (filename.value) {
    // Remove "filename.ext: " from the beginning
    return message.substring(filename.value.length + 2)
  }

  return message
})
</script>
